const IN_APP_BROWSER_PATTERNS = [
  /LinkedIn/i,
  /FBAN|FBAV/i, // Facebook
  /Instagram/i,
  /Twitter/i,
  /; wv\)/i, // Generic Android WebView
];

export const isInAppBrowser = (): boolean =>
  IN_APP_BROWSER_PATTERNS.some((p) => p.test(navigator.userAgent));

export const isAndroid = (): boolean => /Android/i.test(navigator.userAgent);

// iPadOS 13+ reports a macOS desktop UA; the touch-points check catches it.
export const isIOS = (): boolean =>
  /iPhone|iPad/i.test(navigator.userAgent) ||
  (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);

// Android's intent:// scheme is handled at the OS level, bypassing the host
// app's navigation policy entirely — so it works reliably via location.href
// in all in-app browsers (Instagram, Facebook, LinkedIn, etc.).
function getAndroidIntentUrl(): string {
  const { host, pathname, search, hash } = globalThis.location;
  return `intent://${host}${pathname}${search}${hash}#Intent;scheme=https;end`;
}

export function openInBrowser(): void {
  if (isAndroid()) {
    globalThis.location.href = getAndroidIntentUrl();
    return;
  }

  // iOS WKWebView blocks location.href navigation with custom schemes.
  // A target="_blank" anchor click is the only reliable escape from in-app
  // browsers (Instagram, Facebook, LinkedIn, etc.) on iOS.
  //
  // Note: Apple added an `x-safari-https://...` scheme in iOS 17 as a
  // sanctioned escape hatch, but it only works if the host app explicitly
  // allows it in its WKWebView navigation policy — which Instagram, Facebook,
  // and LinkedIn do not. It was also never formally documented, making
  // target="_blank" the safer cross-app choice.
  const a = document.createElement("a");
  a.href = globalThis.location.href;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
